export default class CtaForm {
	constructor(block) {
		this.block = block;
		this.addBtn = this.block.querySelector('.btn-add');
		this.emailCount = 0;

		if (this.addBtn) {
			this.addBtn.addEventListener('click', () => this.addEmailField());
		}
	}

	addEmailField() {
		this.emailCount++;
		const id = `email_additional_${this.emailCount}`;

		const fieldHtml = `
			<div class="input-group input-group-lg email-field-additional">
				<div class="field form-group type-email form-floating label_after flex-grow-1">
					<input type="email" class="form-control input form-control-lg" id="${id}" name="email_additional[]" placeholder="Enter someone else's email" value="" aria-label="Enter someone else's email">
					<label class="label form-label" for="${id}">Enter someone else's email</label>
				</div>
				<button type="button" class="btn btn-outline-secondary btn-remove-email" aria-label="Remove email field">&times;</button>
			</div>
		`;

		const wrapper = document.createElement('div');
		wrapper.innerHTML = fieldHtml.trim();
		const newField = wrapper.firstChild;
		const removeBtn = newField.querySelector('.btn-remove-email');

		removeBtn.addEventListener('click', () => newField.remove());

		this.addBtn.insertAdjacentElement('beforebegin', newField);
	}
}
